import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';

import * as actions from './userInfoActions';
import { USERINFO_REDUCER_KEY } from './userInfoTypes';

const reducer = handleActions(
  {
    [actions.getUserInfo]: (state) => state.merge({ isLoading: true }),
    [actions.getUserInfoSuccess]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),

    [actions.setAlwaysMFA]: (state) => state.merge({ isLoading: true }),
    [actions.setAlwaysMFASuccess]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.setAlwaysMFAFailure]: (state, { payload: error }) => resourceUpserters.resetResources(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore({ resourceName: 'USERINFO' }),
);

export const REDUCER_KEY = USERINFO_REDUCER_KEY;
export default reducer;
